import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { IoFilterOutline } from "react-icons/io5"
import { TbFileExport } from "react-icons/tb"
import { filterProjects } from "../../core/utils/filterProjects"
import { ChipComponent } from "../Chip"
import { FilterModal } from "../../screen/DashboardScreen"
import { jsonToExcel } from "../../core/utils/jsonToExcel"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import { useFilter } from "../../core/utils/hooks/useFilter"
import { Spinner } from "../Loading"
import { useScope } from "../../container/SelectProjectCompanyContainer"
import "./styles.scss"
import { useUsers } from "../../core/utils/hooks/useUsers"
import { useSelector } from "react-redux"

export const formattedProjects = (projects = []) => {
  if (!projects || !projects.length) return []

  const newProjects = [...new Set(projects.map(item => item.id))];
  
  return newProjects.map(projectId => ({
    value: projectId,
    label: projects.find(item => item.id === projectId)?.description
  }));
}

export const SubheaderFilter = ({
  isJourney = true,
  hasFixedYear = false,
  fixedYear,
  loading,
  setLoading,
  isDisabledExport,
  hasExport,
  formatExportData,
  hasDateField = true,
  dateType,
  periodReference,
  keyFilter = "filter",
  technician,
  resetFilter
}) => {
  const { scope, scopeType, projectsByScope } = useScope()
  const [modalIsOpen, setIsOpen] = useState(false)
  const [currentFilterChips, setCurrentFilterChips] = useState([])
  const [values, onChange, , onReload] = useFilter(keyFilter)
  const { reload } = useUsers()
  const [dw] = useDWOptions(values, true);

  const { control } = useForm({
    mode: "onBlur",
  });

  const getDefaultProjects = () => {
    let defaultProjects = [];

    if(scopeType === 'project') {
      defaultProjects.push({ label: scope?.description, value: scope?.id })
    } else if(scopeType === 'company') {
      defaultProjects = scope.projects || [];
    } else if(scopeType === 'organization') {
      scope.companies && scope.companies.map(company => {
        defaultProjects = [...defaultProjects, ...company.projects];
      })
    }

    return defaultProjects.map(row => ({ label: row?.description || row?.label, value: row?.id || row?.value}));
  }

  useEffect(() => {
    if (scope?.id) {
      onChange("projects", getDefaultProjects())
      reload()
    }
  }, [scope?.id])

 useEffect(() => {
    setChipsData({ ...values })
  }, [JSON.stringify(values)])

  const onRemoveChip = async (id, type) => {
    let newFilter = [...currentFilterChips.filter((item) => item.type !== type)]
    let [needReload, newValues] = [false, null]

    if (type === "projects") {
      if (values?.projects && values?.projects.length <= 1 && scope?.description === id) {
        return
      }

      needReload = true
      newValues = values?.projects && values.projects.filter((item) => item.label !== id)

      if (!newValues || !newValues.length) {
        newValues = projectsByScope.map(row => ({ value: row?.id, label: row?.description}).filter(row => row && row.value));
      }

      newFilter = [...newFilter, ...newValues.map((item) => ({ type, value: item?.label }))]
    } else if (type === "year") {
      needReload = true
    } else if (type === "yearReference") {
      needReload = true
    } else if (type === "type") {
      needReload = true
    }

    if (needReload) {
      onChange(type, newValues)
      onReload()
      reload()
      setCurrentFilterChips([...newFilter])
    }
  }

  const transformData = (dataString) => {
    const datas = dataString?.split("|");
    const getDate = (dateString) => dateString?.split("-").reverse().join("/");

    const data1 = getDate(datas[0]);
    const data2 = getDate(datas[1]);

    if (data2 === data1) {
        return data1;
    }

    if (data1 && data2) {
        return `${data1} a ${data2}`;
    }

    return data1 || data2 || '';
  };

  const setChipsData = (newValues) => {
    
    const formatDateChips = (newValues) => {
      const newData = { ...newValues };
    
      if (newValues.yearReference) {
        newData.yearReference = transformData(newValues.yearReference);
      }
    
      if (newValues.year) {
        newData.year = transformData(newValues.year) || null;
      }
    
      return newData;
    };

    let newCurrentFilter = []
    const valueKeys = (formatDateChips(newValues) && Object.keys(formatDateChips(newValues))) || []

    valueKeys.map((valueKey) => {
      if (formatDateChips(newValues) && Array.isArray(formatDateChips(newValues)[valueKey])) {
        newCurrentFilter = [
          ...newCurrentFilter,
          ...formatDateChips(newValues)[valueKey].map((row) => {
            if (valueKey === "projects") return { type: valueKey, value: row?.label }
            else return { type: valueKey, value: row }
          }),
        ]
      } else {
        newCurrentFilter = [...newCurrentFilter, { type: valueKey, value: formatDateChips(newValues)[valueKey] }]
      }
    })

    const hasYear =
      valueKeys.includes("year") &&
      newCurrentFilter.filter((item) => item?.type === "year")[0]?.value

    if (!hasYear && hasFixedYear && fixedYear) {
      newCurrentFilter = [...newCurrentFilter, { type: "year", value: fixedYear, removeIcon: true }]
    }

    const allValues = [
      ...new Set([...newCurrentFilter.map((item) => item?.value).filter((item) => item)]),
    ]

    newCurrentFilter = allValues.map(
      (item) =>
        newCurrentFilter.filter(
          (row) => row?.value === item && row?.type !== "date" && row?.type !== "Atendimento",
        )[0],
    )

    setCurrentFilterChips(newCurrentFilter)
    onReload(false)
  }

  const onSearch = async () => {
    setLoading(true)

    if (!values?.projects || !values.projects.length) {
      onChange("projects", filterProjects(formattedProjects(projectsByScope)))
    }

    onReload(true)
    setIsOpen(false)
  }

  const exportData = async () => {
    const [producersData, contentDataProducers] = await formatExportData()

    const jsonToExport = producersData.sort((a, b) => {
      if (a.ANO < b.ANO) return -1
      if (a.ANO > b.ANO) return 1
      return 0
    })

    const jsonToExportContent = contentDataProducers.sort((a, b) => {
      if (a.ANO > b.ANO) return -1
      if (a.ANO < b.ANO) return 1
      return 0
    })

    await jsonToExcel(
      "jornada_fornecedor",
      jsonToExport || [],
      "ManejeSheet",
      jsonToExportContent,
      "Contéudos Enviados",
    )
  }

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [modalIsOpen])

  return (
    <>
      <div className="subheader-filter">
        <div className="filter-chips">
        {loading ? (
            <div className="loading-subheader">
              <Spinner size="xsmall" color="primary" />
            </div>
          ) : <></>}
          <ChipComponent
            onRemove={onRemoveChip}
            label={
              Array.isArray(currentFilterChips)
                ? currentFilterChips.filter(
                    (item) => typeof item.value === "string" || typeof item.value === "number",
                  )
                : []
            }
          />
          <div className="filter-button-container" onClick={() => openModal()}>
            <IoFilterOutline className="icon-filter" />
            <text className="text-filter">Filtrar</text>
          </div>

          {hasExport && (
          <div
            className={`filter-button-container export-journey ${isDisabledExport ? "disabled" : ""}`}
            onClick={exportData}>
            <TbFileExport className="icon-filter" />
            <text className="text-filter">Exportar</text>
          </div>
        )}
        </div>
        
      </div>
      <FilterModal
        {...{
          type: dateType || "year",
          modalIsOpen,
          setModalIsOpen: setIsOpen,
          period: isJourney,
          onChange: (name) => (event) => {
            onChange(name, (event?.target && event?.target?.value) || event)
          },
          control,
          reload: () => onReload(),
          onSearch,
          loading: loading,
          periodReference,
          dw: { ...dw, 
            projects: filterProjects(formattedProjects(projectsByScope) || []), 
            tecnico: technician },
          values,
          useFarmers: false,
          useForms: false,
          hasDateField,
          resetFilter
        }}
      />
    </>
  )
}
